import {formErrorMap} from './zodFormErrorMap';

import type {StandardSchemaV1} from '@tanstack/react-form';
import type {z} from 'zod';

/**
 * Wraps a Zod schema as a Standard Schema for TanStack Form's
 * `validators.onSubmit`/`onBlur`/`onChange`, resolving messages through
 * `formErrorMap` instead of Zod's stock defaults. TanStack Form detects any
 * object with a `~standard` property and calls its `validate(value)` with no
 * way to pass a contextual error map — this mirrors Zod's own `~standard`
 * implementation (see zod/v4/core/schemas.js) but adds one.
 */
export function zodTanstackValidate<T extends z.ZodType>(
  schema: T
): StandardSchemaV1<z.input<T>, z.output<T>> {
  return {
    '~standard': {
      version: 1,
      vendor: 'zod-form-error-map',
      validate: (value) => {
        const result = schema.safeParse(value, {error: formErrorMap});
        return result.success
          ? {value: result.data}
          : {issues: result.error.issues};
      },
    },
  };
}
